import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  QUERIES,
  WithChildren,
  buildQueryString,
  createResponseContext,
  initialQueryResponse,
} from '_metronic/helpers'
import { SncrNumeroUsado } from '../../core/_models'
import { getSncrNumerosDoBloco } from '../../core/_requests'
import { useQueryRequest } from './QueryRequestProvider'

const QueryResponseContext = createResponseContext<SncrNumeroUsado>(initialQueryResponse)

type IProps = WithChildren & {
  idBloco: number
}

export const QueryResponseProvider: FC<IProps> = ({ idBloco, children }) => {
  const { state } = useQueryRequest()

  const query = useMemo(() => {
    const parametros = buildQueryString({ page: state.page, size: state.size })
    // Sort montado à mão: o separador do Spring é a vírgula literal.
    const sort = `sort=${state.sort ?? 'numeroSncr'},${state.order ?? 'desc'}`
    return [parametros, sort].filter(Boolean).join('&')
  }, [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.SNCR_NUMEROS_LIST, idBloco, query],
    () => getSncrNumerosDoBloco(idBloco, query),
    { keepPreviousData: true, refetchOnWindowFocus: false }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
